export function getDisplayedRowsCount(
  tablet: boolean | null,
  smallDesktop: boolean | null
): number {
  if (smallDesktop) {
    return 6;
  } else if (tablet) {
    return 4;
  }

  return 3;
}
